import { render } from "./IconWarningTriangleFilled.vue?vue&type=template&id=035becb2"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconWarningTriangleFilled.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "035becb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('035becb2', __exports__)) {
    api.reload('035becb2', __exports__)
  }
  
  module.hot.accept("./IconWarningTriangleFilled.vue?vue&type=template&id=035becb2", () => {
    api.rerender('035becb2', render)
  })

}


export default __exports__